import isFalsy from '@bitty/falsy';
import None from './None.js';
import Some from './Some.js';
export default function fromFalsy(value) {
    return isFalsy(value) ? None : Some(value);
}
//# sourceMappingURL=fromFalsy.js.map